








export default {
  name: 'basic-list'
}
